export const TUBRO_CHARGER_MAX_RPM = 1000;

export const PRIME_MOVER_TYPES = [
  'two_stroke_engine',
  'four_stroke_engine',
  'lbsi'
];

export const LUBE_OIL_FIELDS = [
  'report.bunker.lube_started_bunkering_date',
  'report.bunker.lube_bunkering_date',
  'report.bunker.quantity_received_me_lube_oil_system',
  'report.bunker.bdn_figures_me_lube_oil_system',
  'report.bunker.quantity_received_me_lube_oil_spare',
  'report.bunker.bdn_figures_me_lube_oil_spare',
  'report.bunker.quantity_received_cylinder_oil_low_bn',
  'report.bunker.bdn_figures_cylinder_oil_low_bn',
  'report.bunker.quantity_received_cylinder_oil',
  'report.bunker.bdn_figures_cylinder_oil',
  'report.bunker.quantity_received_ae_lube_oil',
  'report.bunker.bdn_figures_ae_lube_oil',
  'report.bunker.quantity_received_turbo_oil',
  'report.bunker.bdn_figures_turbo_oil',
  'report.bunker.quantity_received_hydraulic_oil',
  'report.bunker.bdn_figures_hydraulic_oil',
  'report.bunker.quantity_received_ho_mooring',
  'report.bunker.bdn_figures_ho_mooring',
  'report.bunker.quantity_received_ho_cranes',
  'report.bunker.bdn_figures_ho_cranes',
  'report.bunker.quantity_received_ho_grabs',
  'report.bunker.bdn_figures_ho_grabs',
  'report.bunker.quantity_received_ho_hatch',
  'report.bunker.bdn_figures_ho_hatch',
  'report.bunker.quantity_received_gasoline',
  'report.bunker.bdn_figures_gasoline',
  'report.bunker.quantity_received_other_oil',
  'report.bunker.bdn_figures_other_oil',
  'report.bunker.lube_lop'
];

export const LUBE_OIL_FORM_FIELDS = [
  'reportForm.bunker.oilStartedBunkering',
  'reportForm.bunker.oilBunkeringDate',
  'reportForm.bunker.meLubeOilSystem',
  'reportForm.bunker.bdnFiguresMeLubeOilSystem',
  'reportForm.bunker.meLubeOilSpare',
  'reportForm.bunker.bdnFiguresMeLubeOilSpare',
  'reportForm.bunker.cylinderOilLow',
  'reportForm.bunker.bdnFiguresCylinderOilLowBN',
  'reportForm.bunker.cylinderOil',
  'reportForm.bunker.bdnFiguresCylinderOil',
  'reportForm.bunker.auxEngineLubeOil',
  'reportForm.bunker.bdnFiguresAeLubeOil',
  'reportForm.bunker.turboOil',
  'reportForm.bunker.bdnFiguresTurboOil',
  'reportForm.bunker.hydraulicOil',
  'reportForm.bunker.bdnFiguresHydraulicOil',
  'reportForm.bunker.hoMooring',
  'reportForm.bunker.bdnFiguresHoMooring',
  'reportForm.bunker.hoCranes',
  'reportForm.bunker.bdnFiguresHoCranes',
  'reportForm.bunker.hoGrabs',
  'reportForm.bunker.bdnFiguresHoGrabs',
  'reportForm.bunker.hoHatch',
  'reportForm.bunker.bdnFiguresHoHatch',
  'reportForm.bunker.gasoline',
  'reportForm.bunker.bdnFiguresGasoline',
  'reportForm.bunker.otherOil',
  'reportForm.bunker.bdnFiguresOtherOil'
];
